import { Button } from "react-bootstrap";
import PageTemplate from "../../templates/Pagetemplate";
import BreadCrumb from "../../molecules/BreadCrumb";
import styled from "styled-components";
import { useForm } from "react-hook-form";
import BranchForm from "../../organisms/BranchForm";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { showAlert } from "../../../../reducer/alertSlice";
import axios from "axios";
import { useCheckDirtyField, useRefresh } from "../../../common/hook";
import { hideConfirm, showConfirm } from "../../../../reducer/confirmSlice";
import Loading from "../../organisms/Loading";
import AccessDenied from "../AuthPage/AccessDenied";



const Wrap = styled.div`
    .form-label {
        min-width: 170px;

        & + div[class^=col] {
            flex: 1 1;
        }
    }

    .form-check-label {
        white-space: nowrap;
        font-size: 14px;
    }
`;
export default function DetailBranch(props) {
    const {id} = useParams();
    const form = useForm();
    const loginInfo = useSelector(state => state.login);


    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {checkFieldConfirm} = useCheckDirtyField();

    const refresh = useRefresh();

    const [defaultData, setDefaultData] = useState();
    const [initData, setInitData] = useState();
    const [dirty, setDirty] = useState(false);

    const onSubmit = form.handleSubmit((data) => {
        branchUpdate.mutate();
    });

    // 지점 상세
    const detailBranchQuery = useQuery({
        queryKey: ['DetailBranch', id],
        refetchOnWindowFocus: false,
        retry: 1, 
        queryFn: () => {
            return axios("/branch/detail/" + id, {
                method: "GET",
            }).then(result => {
                setDefaultData({...result.data.data, ownerName: result.data.data.owner});
                const branchArr = [];
                const generalArr = [];
                const ipArr = [];
                result.data.data.branchAdmin.map(el => {
                    branchArr.push(el.phone);
                })
                result.data.data.generalAdmin.map(el => {
                    generalArr.push(el.phone);
                })
                setInitData({
                    ...result.data.data,
                    ownerName: result.data.data.owner,
                    branchAdminList: branchArr, 
                    generalAdminList: generalArr
                })

                return result;
            })
        }
    });

    // 지점 수정
    const branchUpdate = useMutation({
        mutationKey: ['branchUpdate'],
        mutationFn: () => {
            const values = form.getValues();
            return axios("/branch/update/" + id, {
                method: "PUT",
                headers: {
                    "Content-Type": "multipart/form-data"
                },
                data: {
                    branchName: values.branchName,
                    storeId: values.storeId,
                    ownerName: values.ownerName,
                    tel: values.branchTelArea + "-" + values.telNum,
                    registrationNo: values.registrationNo,
                    region: values.region,
                    address: values.address,
                    useIp: values.useIp,
                    ipList: values.ipList,
                    branchAdminList: values.branchAdminList,
                    generalAdminList: values.generalAdminList,
                    registrationFile: values.registrationFile[0], 
                    contractFile: values.contractFile.length > 0 ? values.contractFile[0] : "", 
                }
            }).then(result => {
                if (result.status == 201) {
                    dispatch(showAlert({
                        msg: "수정되었습니다.",
                        func: () => {
                            navigate("/admin/list/branch");
                            refresh.refetch();
                        }
                    }))
                } else {
                    dispatch(showAlert({
                        msg: "처리 중 오류가 발생했습니다."
                    }))
                }
                return result.data;
            }).catch(error => {
                dispatch(showAlert({
                    msg: error.response?.data?.msg?.ko ? error.response?.data?.msg?.ko : "처리 중 오류가 발생했습니다."
                }))
            })
        }
    });
    
    // 지점 삭제
    const deleteBranch = useMutation({
        mutationKey: ['deleteBranch'],
        mutationFn: () => {
            return axios("/branch/delete/" + id, {
                method: "DELETE",
            }).then(result => {
                if (result.status == "204") {
                    dispatch(showAlert({
                        msg: "삭제되었습니다.",
                        func: () => {
                            navigate("/admin/list/branch");
                            refresh.refetch();
                        }
                    }))
                    
                } else {
                    dispatch(showAlert({
                        msg: <>삭제 도중 오류가 발생했습니다.<br/>잠시 후 다시 시도해주세요.<br/>ERROR STATUS: {result.status}</>
                    }))
                }

                return result.data;
            });
        }
    });

    useEffect(() => {
        const subscription = form.watch((value, { name, type }) => {
            for (const key in defaultData) {
                let formVal = value[key];
                if (key == "tel") {
                    formVal = value['branchTelArea'] + "-" + value['telNum'];
                }
                switch (key) {
                    case "storeId":
                    case "ownerName":
                    case "tel":
                    case "registrationNo":
                    case "region":
                    case "useIp":
                        if (initData[key] != formVal) {
                            setDirty(true);
                        }
                        break;
                        
                    case "ipList":
                    case "branchAdminList":
                    case "generalAdminList":
                        if (JSON.stringify(initData[key]) != JSON.stringify(value[key])) {
                            setDirty(true);
                        }
                        break;
                        
                
                    default:
                        break;
                }
            }
        });
        return () => subscription.unsubscribe();
    }, [form.watch, defaultData]);

    useEffect(() => {
        if (detailBranchQuery.isError) {
            if (detailBranchQuery.error.response) {
                if (detailBranchQuery.error.response.status == 403) {
                    navigate("/error/accessDenied");
                } else {
                    dispatch(showAlert({
                        msg: detailBranchQuery.error.response.data.msg.ko,
                        func: () => {
                            navigate(-1);
                        }
                    }))
                }
            }
        }

    },[detailBranchQuery.isError]);

    if (detailBranchQuery.isRefetching || detailBranchQuery.isLoading) {
        return <Loading/>
    }
    if (!detailBranchQuery.isRefetching && defaultData) {
        return (
            <Wrap>
                <PageTemplate.Top>
                    <BreadCrumb arr={[<Link to="/admin/list/company">관리자 설정</Link>, <Link to="/admin/list/branch">지점 관리</Link>, <span className="fw-bold">지점 상세</span>]} />
                    <h1 className="page-title">지점 상세</h1>
                </PageTemplate.Top>
                <PageTemplate.Content>
                    <BranchForm form={form} isDetail={true} defaultData={initData}/>
                </PageTemplate.Content>

                <PageTemplate.ButtonContainer className={loginInfo.admin.level < 3 ? "mt-3 justify-content-between" : "mt-3 justify-content-end"}>
                    {
                    loginInfo.admin.level < 3 &&
                    <Button className="me-2" variant="outline-danger"
                    onClick={() => {
                        dispatch(showConfirm({
                            msg: "정말 해당 지점을 삭제하시겠어요?", 
                            btnText: "삭제",
                            func: async () => {
                                function getBranchNum() {
                                    return axios.get("company/branch/" + detailBranchQuery.data.data.data.companyId)
                                }
                                if ((await getBranchNum()).data.data < 2) {
                                    dispatch(showAlert({
                                        msg: <>지점 삭제가 불가합니다.<br/>최소 1개 이상의 지점이 등록되어 있어야합니다.</>
                                    }))
                                } else {
                                    deleteBranch.mutate();
                                }
                                dispatch(hideConfirm());
                            }
                        }))
                    }}
                    >삭제</Button>
                    }

                    <div>
                        <Button className="me-2" variant="outline-secondary"
                        onClick={() => {
                            checkFieldConfirm(dirty);
                        }}
                        >취소</Button>
                        <Button variant="primary" onClick={() => {
                            onSubmit()
                        }}>수정</Button>
                    </div>
                </PageTemplate.ButtonContainer>
            </Wrap>
        );
    }
}
